import React from 'react';
export const errorFormMessage = (message) => (
  <p style={{ color: 'red' }}>{message}</p>
);
